import React from 'react';
import { useTranslation } from 'react-i18next';
import SVGImage from './SVGImage';

interface ToggleOperationProps {
  testId?: string;
  className?: string;
  isOperation?: boolean;
  onClick?: () => void;
}

export const ToggleOperation: React.FC<ToggleOperationProps> = ({
  testId,
  className,
  isOperation,
  onClick,
}) => {
  const { t } = useTranslation();
  const text = isOperation
    ? t('sidebar.toggle', { context: 'dashboard' })
    : t('sidebar.toggle', { context: 'operation' });
  return (
    <div
      data-testid={testId}
      onClick={() => onClick?.()}
      className={`pop-11-semibold flex h-[30px] w-[122px] items-center justify-center rounded-[60px] bg-dark-5 text-white ${className}`}
    >
      <SVGImage name="conversion" width={18} height={18} className="mr-[8px]" />
      {text}
    </div>
  );
};
